import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTrigger } from '@companion-professional/components';
import { linkVariants } from '../../../Typography';

/**
 * This component is used to display a popup dialog when a link is clicked.
 * children is the linked text that will be displayed. It's the string present inside [] in the markdown
 * or <PopupDialog> ... </PopupDialog> in react. It's a special props which react uses to pass content between tags to
 * the components - for popup dialog it's always going to be the trigger text for dialog
 * dialogContent is the content of the popup dialog, which can be any valid react node,
 * for example:
 * <div>
 *   <h1>Terms of Service</h1>
 *   <p>This is the content of the popup dialog.</p>
 * </div>
 */
export const PopupDialog = ({
  children: triggerDialogText,
  dialogContent,
  dialogContentClassName
}: {
  children: React.ReactNode;
  dialogContent: React.ReactNode;
  dialogContentClassName?: string;
}) => {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <span className={linkVariants()}>{triggerDialogText}</span>
      </DialogTrigger>
      <DialogContent className={dialogContentClassName}>{dialogContent}</DialogContent>
    </Dialog>
  );
};
